import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.ggeea_admin');
import { ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-layout-ggeea_admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.ggeea_admin/view.scss */
:host {
  display: block;
  height: 100dvh;
  min-height: 100dvh;
  width: 100%;
  background: #e9eef3;
}

.admin-shell {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100dvh;
  overflow: hidden;
  background: linear-gradient(180deg, #f8fafc 0%, #edf2f7 100%);
}

.admin-sidebar {
  width: 272px;
  min-width: 272px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 14px 14px;
  color: #0f172a;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  box-shadow: inset -1px 0 0 rgba(148, 163, 184, 0.2), 18px 0 38px -34px rgba(15, 23, 42, 0.16);
}

.admin-sidebar__brand {
  padding: 14px 14px 16px;
  border-radius: 22px;
  border: 1px solid rgba(226, 232, 240, 0.96);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 20px 40px -34px rgba(15, 23, 42, 0.18);
}

.admin-sidebar__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 9px;
  border-radius: 999px;
  background: #ecfeff;
  color: #0f766e;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.admin-sidebar__logo {
  display: block;
  width: 100%;
  height: auto;
  margin: 12px 0 10px;
  object-fit: contain;
  filter: drop-shadow(0 6px 12px rgba(148, 163, 184, 0.16));
}

.admin-sidebar__title {
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.admin-sidebar__subtitle {
  margin-top: 4px;
  color: rgba(71, 85, 105, 0.78);
  font-size: 11px;
  line-height: 1.5;
}

.admin-sidebar__nav {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-sidebar__nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 16px;
  color: rgba(51, 65, 85, 0.86);
  text-decoration: none;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.admin-sidebar__nav-link:hover {
  background: rgba(148, 163, 184, 0.1);
  color: #0f172a;
  transform: translateX(2px);
}

.admin-sidebar__nav-link.is-active {
  color: #ffffff;
  background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);
  box-shadow: 0 18px 28px -24px rgba(15, 23, 42, 0.5);
}

.admin-sidebar__nav-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(203, 213, 225, 0.9);
  background: #e2e8f0;
  color: #475569;
  transition: background 0.18s ease, color 0.18s ease;
}

.admin-sidebar__nav-link.is-active .admin-sidebar__nav-icon {
  border-color: rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.admin-sidebar__nav-label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.admin-sidebar__footer {
  margin-top: auto;
  padding: 14px;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.98);
  background: #ffffff;
  box-shadow: 0 20px 40px -34px rgba(15, 23, 42, 0.14);
}

.admin-sidebar__footer-label {
  color: #64748b;
  font-size: 11px;
}

.admin-sidebar__footer-name {
  margin-top: 6px;
  color: #0f172a;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.admin-sidebar__footer-email {
  margin-top: 4px;
  color: rgba(71, 85, 105, 0.76);
  font-size: 13px;
}

.admin-sidebar__logout {
  width: 100%;
  margin-top: 14px;
  padding: 11px 12px;
  border: 0;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #0f172a;
  color: #f8fafc;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;
}

.admin-sidebar__logout:hover {
  background: #1e293b;
  transform: translateY(-1px);
}

.admin-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  background: radial-gradient(circle at top right, rgba(16, 185, 129, 0.1), transparent 24%), radial-gradient(circle at top left, rgba(59, 130, 246, 0.08), transparent 20%), linear-gradient(180deg, #f8fafc 0%, #eef2f4 100%);
}

.admin-main__inner {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

:host ::ng-deep .admin-main__inner > router-outlet + * {
  display: block;
  flex: 1 0 auto;
  min-height: 100%;
  animation: admin-page-enter 280ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

:host ::ng-deep .admin-main__inner > router-outlet + * .admin-page > * {
  animation: admin-section-enter 320ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

:host ::ng-deep .admin-main__inner > router-outlet + * .admin-page > :nth-child(2) {
  animation-delay: 35ms;
}

:host ::ng-deep .admin-main__inner > router-outlet + * .admin-page > :nth-child(3) {
  animation-delay: 70ms;
}

:host ::ng-deep .admin-main__inner > router-outlet + * .admin-page > :nth-child(n+4) {
  animation-delay: 95ms;
}

:host ::ng-deep .admin-main :is(button, a, [role=button]),
.admin-sidebar :is(button, a, [role=button]) {
  -webkit-tap-highlight-color: transparent;
  transition-property: color, background-color, border-color, box-shadow, opacity, transform;
  transition-duration: 180ms;
  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
}

:host ::ng-deep .admin-main :is(button, a, [role=button]):active:not(:disabled),
.admin-sidebar :is(button, a, [role=button]):active:not(:disabled) {
  transform: translateY(1px) scale(0.985);
  transition-duration: 70ms;
}

:host ::ng-deep .admin-main :is(button, a, input, select, textarea):focus-visible,
.admin-sidebar :is(button, a):focus-visible {
  outline: 2px solid rgba(5, 150, 105, 0.72);
  outline-offset: 2px;
}

:host ::ng-deep .admin-main :is(input, select, textarea) {
  transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}

:host ::ng-deep .admin-main :is(.faq-item-card,
.rag-doc-card,
.admin-history__card,
.dashboard-recent__card,
.stats-keyword-row,
.report-list__row) {
  animation: admin-item-enter 240ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

:host ::ng-deep .admin-main :is(.faq-item-card,
.rag-doc-card,
.admin-history__card,
.dashboard-recent__card,
.stats-keyword-row,
.report-list__row):nth-child(2) {
  animation-delay: 24ms;
}

:host ::ng-deep .admin-main :is(.faq-item-card,
.rag-doc-card,
.admin-history__card,
.dashboard-recent__card,
.stats-keyword-row,
.report-list__row):nth-child(3) {
  animation-delay: 48ms;
}

:host ::ng-deep .admin-main :is(.faq-item-card,
.rag-doc-card,
.admin-history__card,
.dashboard-recent__card,
.stats-keyword-row,
.report-list__row):nth-child(n+4) {
  animation-delay: 64ms;
}

:host ::ng-deep .admin-main .fixed.inset-0.z-50 {
  animation: admin-backdrop-enter 180ms ease-out both;
}

:host ::ng-deep .admin-main .fixed.inset-0.z-50 > * {
  animation: admin-dialog-enter 240ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

:host ::ng-deep .admin-main :is(.admin-page__loading, .report-loading, .admin-history__panel-empty) {
  animation: admin-status-enter 220ms ease-out both;
}

@keyframes admin-page-enter {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes admin-section-enter {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes admin-item-enter {
  from {
    opacity: 0;
    transform: translateY(4px) scale(0.995);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes admin-backdrop-enter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes admin-dialog-enter {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes admin-status-enter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host ::ng-deep .admin-main *,
  :host ::ng-deep .admin-main *::before,
  :host ::ng-deep .admin-main *::after,
  .admin-sidebar *,
  .admin-sidebar *::before,
  .admin-sidebar *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-delay: 0ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
@media (max-width: 1200px) {
  .admin-sidebar {
    width: 248px;
    min-width: 248px;
  }
  .admin-sidebar__footer-name {
    font-size: 20px;
  }
}`],
})
export class LayoutGgeea_adminComponent implements OnInit, OnDestroy {
    public user: any = null;
    private routerSub: any = null;
    public menu = [
        { label: '대시보드', icon: 'fa-solid fa-chart-line', path: '/admin/dashboard' },
        { label: '대화 이력', icon: 'fa-solid fa-comments', path: '/admin/chats' },
        { label: '통계', icon: 'fa-solid fa-chart-pie', path: '/admin/stats' },
        { label: '운영 보고서', icon: 'fa-solid fa-file-lines', path: '/admin/reports' },
        { label: '설정', icon: 'fa-solid fa-gear', path: '/admin/settings/faq' },
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ElementRef)         private host: ElementRef,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef,    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindNavigator((path: string) => this.router.navigateByUrl(path));
        this.routerSub = this.router.events.subscribe((event) => {
            if (!(event instanceof NavigationEnd)) return;
            const main = this.host.nativeElement.querySelector('.admin-main');
            if (main) main.scrollTop = 0;
            try { this.cdr.detectChanges(); } catch (e) { }
        });
        this.user = await this.service.me();
        if (!this.user) {
            this.service.href('/admin/login');
            return;
        }
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        this.service.bindNavigator(null);
    }

    public isActive(path: string): boolean {
        const cur = location.pathname;
        if (path === '/admin/settings/faq') return cur.startsWith('/admin/settings');
        return cur === path || cur.startsWith(path + '/');
    }

    public trackPath = (_: number, m: any) => m.path;

    public menuClass(m: any): string {
        const base = 'admin-sidebar__nav-link';
        const active = this.isActive(m.path) ? ' is-active' : '';
        return base + active;
    }

    public async logout() {
        await this.service.logout();
    }
}

export default LayoutGgeea_adminComponent;